// Tier 3 (AI TRADER) — 25 lessons across modules 3.1–3.5.
// Static imports so the PWA bundles lesson data at build time (zero network calls, works offline).
import lessonsT3_1to2 from "./axel-lessons-3.1.1-to-3.2.5.json";
import lessonsT3_3to4 from "./axel-lessons-3.3.1-to-3.4.5.json";
import lessonsT3_5 from "./axel-lessons-3.5.1-to-3.5.5.json";
import { normalizeLesson } from "./normalizeQuiz";

const unwrap = (src) => (Array.isArray(src) ? src : src?.lessons || []);

export const TIER3_LESSONS = [
  ...unwrap(lessonsT3_1to2),
  ...unwrap(lessonsT3_3to4),
  ...unwrap(lessonsT3_5),
].map(normalizeLesson);
